import { EventCardProps, UI_EventCard } from 'ui/components/2-molecules/Card/EventCard/EventCard';
import styles from './EventOverview.module.scss';
import { UI_Button } from 'ui/components/1-atoms/Action/Button/Button';

export interface EventOverviewProps {
	cards: EventCardProps[];
	paginationText: string;
	requestMoreCards?: () => void;
}

export const UI_EventOverview = ({ cards, paginationText, requestMoreCards }: EventOverviewProps) => {
	return (
		<div className={styles.EventOverview}>
			{cards?.map((card, index) => {
				return <UI_EventCard className={styles.EventOverview_card} key={index} {...card} />;
			})}
			{paginationText && (
				<div className={styles.EventOverview_pagination}>
					<UI_Button style="secondary" onClick={requestMoreCards}>
						{paginationText}
					</UI_Button>
				</div>
			)}
		</div>
	);
};
